/**
 * Bearing and pitch deltas for Rotate View.
 *
 * Horizontal drag changes bearing. Vertical drag changes pitch, the same
 * split MapLibre uses for a right-drag. Dragging right increases bearing
 * (clockwise). Dragging up increases pitch (the camera tilts toward the
 * horizon). Pitch stays inside {@link MIN_PITCH}..{@link MAX_PITCH}.
 */

/** Degrees of bearing added per pixel dragged to the right. */
export const BEARING_DEG_PER_PX = 0.8;

/** Degrees of pitch added per pixel dragged up. */
export const PITCH_DEG_PER_PX = 0.5;

export const MIN_PITCH = 0;
export const MAX_PITCH = 60;

export function clampPitch(pitch: number): number {
  return Math.min(MAX_PITCH, Math.max(MIN_PITCH, pitch));
}

/** Next bearing and pitch after one drag sample. `dy` is positive downward. */
export function applyViewRotate(
  bearing: number,
  pitch: number,
  dx: number,
  dy: number,
): { bearing: number; pitch: number } {
  return {
    bearing: bearing + dx * BEARING_DEG_PER_PX,
    pitch: clampPitch(pitch - dy * PITCH_DEG_PER_PX),
  };
}
